/** RAG rating vocabulary with non-expert-friendly copy (spec §1). */

import type { Rag } from "./types";

export interface RagOptionDef {
  value: Rag;
  label: string;
  description: string;
  /** Tailwind colour token for the dot/border (text never relies on colour alone). */
  dot: string;
  ring: string;
  text: string;
}

export const RAG_OPTIONS: RagOptionDef[] = [
  {
    value: "green",
    label: "Looks good",
    description: "Did the right thing — nothing I'd change.",
    dot: "bg-emerald-500",
    ring: "border-emerald-500 ring-emerald-500/30",
    text: "text-emerald-600 dark:text-emerald-400",
  },
  {
    value: "amber",
    label: "Mostly okay",
    description: "Roughly right, but something felt off or unclear.",
    dot: "bg-amber-500",
    ring: "border-amber-500 ring-amber-500/30",
    text: "text-amber-600 dark:text-amber-400",
  },
  {
    value: "red",
    label: "Got it wrong",
    description: "Wrong move, confusing, or shouldn't have done this.",
    dot: "bg-rose-500",
    ring: "border-rose-500 ring-rose-500/30",
    text: "text-rose-600 dark:text-rose-400",
  },
];

export function ragOption(value: Rag): RagOptionDef {
  return RAG_OPTIONS.find((o) => o.value === value) ?? RAG_OPTIONS[0];
}
